import type { AuthSession } from "./types";
import { authenticatedFetch } from "./auth";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string | undefined;

export type PilotRole = {
  person: string;
  role: string;
  scope: string;
};

export type PilotCustomer = {
  customer: string;
  sites: string;
  focus: string;
};

export type PilotReportTemplate = {
  title: string;
  description: string;
};

export type PilotProfile = {
  organizationId: string;
  tenantId: string;
  checklist: Record<string, boolean>;
  roles: PilotRole[];
  customers: PilotCustomer[];
  reportTemplates: PilotReportTemplate[];
  createdAt: string;
  updatedAt: string;
  updatedBy?: string;
  updatedByEmail?: string;
};

export type PilotProfileUpdate = Partial<Pick<
  PilotProfile,
  "checklist" | "roles" | "customers" | "reportTemplates"
>>;

export function getRemotePilotProfile(session: AuthSession) {
  return request<{ item: PilotProfile }>("/pilot", session).then((value) => value.item);
}

export function updateRemotePilotProfile(input: PilotProfileUpdate, session: AuthSession) {
  return request<{ item: PilotProfile }>("/pilot", session, {
    method: "PATCH",
    body: JSON.stringify(input),
  }).then((value) => value.item);
}

async function request<T>(path: string, session: AuthSession, init: RequestInit = {}): Promise<T> {
  if (!API_BASE_URL) throw new Error("API_NOT_CONFIGURED");
  const response = await authenticatedFetch(`${API_BASE_URL}${path}`, session, init);
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const code = typeof body?.error === "string" ? body.error : `HTTP_${response.status}`;
    throw new Error(code);
  }
  return body as T;
}
